import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=64370e15&scoped=true&"
import script from "./promote.vue?vue&type=script&lang=js&"
export * from "./promote.vue?vue&type=script&lang=js&"
import style1 from "./promote.vue?vue&type=style&index=1&id=64370e15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64370e15",
  null
  
)

export default component.exports